<div bsModal #childModal="bs-modal" class="modal fade" [config]="{ backdrop: 'static', keyboard: false }" tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-popup">
    <div class="modal-content">
      <svg>
        <style>{{popupSettings.customStyles}}</style>
      </svg>
      <div class="modal-body">
        <button class="modal-btn-dismiss" (click)="dismissModal()">{{popupSettings.dismissText}}</button>
        <div class="modal-image center">
          <div class="banner-area">
            <a class="modal-btn-cta" [target]="popupSettings.ctaTarget" (click)="ctaModal()">{{popupSettings.ctaText}}</a>
          </div>
          <img src="{{popupSettings.imageContent}}" class="img-fluid">
        </div>
      </div>
      <div class="modal-footer">
        <div class="modal-cta">
          <a class="modal-btn-moreinfo" [target]="popupSettings.moreInfoTarget" (click)="moreInfoModal()">{{popupSettings.moreInfoText}}</a>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/modal-popup/modal-popup.component.html